import { render, staticRenderFns } from "./BasicInfoSettings.vue?vue&type=template&id=7bcd1dc2&scoped=true"
import script from "./BasicInfoSettings.vue?vue&type=script&lang=js"
export * from "./BasicInfoSettings.vue?vue&type=script&lang=js"
import style0 from "./BasicInfoSettings.vue?vue&type=style&index=0&id=7bcd1dc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcd1dc2",
  null
  
)

export default component.exports